import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Products from "@/components/Products";
import Reviews from "@/components/Reviews";
import Payments from "@/components/Payments";
import Footer from "@/components/Footer";
import CheckoutModal from "@/components/CheckoutModal";
import AdminPage from "@/components/AdminPage";
import AccountPage from "@/components/AccountPage";
import PaymentResult from "@/components/PaymentResult";
import { API, BACKEND } from "@/config/site";

function Landing() {
  const [dealEnd, setDealEnd] = useState(null);
  const [checkoutProduct, setCheckoutProduct] = useState(null);
  const [images, setImages] = useState({});

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((r) => setDealEnd(r.data.deal_end))
      .catch(() => setDealEnd(new Date(Date.now() + 14 * 864e5).toISOString()));
    axios
      .get(`${API}/images`)
      .then((r) => {
        const m = {};
        for (const [k, v] of Object.entries(r.data)) {
          m[k] = v.startsWith("/") ? `${BACKEND}${v}` : v;
        }
        setImages(m);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white overflow-x-clip">
      <Hero dealEnd={dealEnd} heroImage={images.hero} />
      <Marquee />
      <Products onBuy={setCheckoutProduct} images={images} />
      <Reviews />
      <Payments />
      <Footer />
      {checkoutProduct && (
        <CheckoutModal product={checkoutProduct} onClose={() => setCheckoutProduct(null)} />
      )}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult canceled />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
